document.addEventListener('DOMContentLoaded', () => {
  const toast = document.getElementById('KCToast');
  let toastTimer;

  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2200);
  };

  // Copy discount code
  document.querySelectorAll('[data-copy-code]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const code = btn.dataset.copyCode;
      try { await navigator.clipboard.writeText(code); } catch(e) {}
      showToast(`${code} copiado ✓`);
    });
  });

  // Reveal animations
  const reveal = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        reveal.unobserve(entry.target);
      }
    });
  }, {threshold:.08});
  document.querySelectorAll('.kc-reveal').forEach(el => reveal.observe(el));

  // Delivery dates
  const delivery = document.querySelector('[data-delivery-widget]');
  if (delivery) {
    const addDays = (d,n) => { const x = new Date(d); x.setDate(x.getDate()+n); return x; };
    const months = ['ene','feb','mar','abr','may','jun','jul','ago','sept','oct','nov','dic'];
    const fmt = d => `${d.getDate()} ${months[d.getMonth()]}`;
    const now = new Date();
    delivery.querySelector('[data-delivery="order"]').textContent = fmt(now);
    delivery.querySelector('[data-delivery="ship"]').textContent = fmt(addDays(now,1));
    delivery.querySelector('[data-delivery="arrival"]').textContent = fmt(addDays(now,3));
  }

  // Product quantity
  const qtyInput = document.querySelector('.kc-buy-form input[name="quantity"]');
  document.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
    if (qtyInput) qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1);
  });
  document.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
    if (qtyInput) qtyInput.value = Math.max(1, Number(qtyInput.value || 1) + 1);
  });

  // Product gallery — preload images so switching is immediate
  const mainImg = document.getElementById('KCMainProductImage');
  const galleryThumbs = Array.from(document.querySelectorAll('[data-product-thumb]'));

  if (mainImg && galleryThumbs.length) {
    const galleryImages = galleryThumbs
      .map(t => t.dataset.imageSrc)
      .filter(Boolean);

    // Preload every product image as soon as the page is ready.
    galleryImages.forEach(src => {
      const img = new Image();
      img.decoding = 'async';
      img.src = src;
    });

    const switchGalleryImage = (thumb) => {
      const src = thumb.dataset.imageSrc;
      if (!src) return;

      galleryThumbs.forEach(t => t.classList.remove('is-selected'));
      thumb.classList.add('is-selected');

      // No artificial timeout: browser swaps to the already-preloaded image.
      mainImg.classList.add('kc-image-changing');
      const next = new Image();
      next.decoding = 'async';
      next.onload = () => {
        requestAnimationFrame(() => {
          mainImg.src = src;
          mainImg.removeAttribute('srcset');
          mainImg.classList.remove('kc-image-changing');
        });
      };
      next.onerror = () => {
        mainImg.src = src;
        mainImg.removeAttribute('srcset');
        mainImg.classList.remove('kc-image-changing');
      };
      next.src = src;
    };

    galleryThumbs.forEach(thumb => {
      thumb.addEventListener('click', () => switchGalleryImage(thumb));
    });
  }

  // Variant availability / price
  const variantSelect = document.getElementById('KCVariant');
  const addButton = document.querySelector('.kc-buy-form .kc-add-cart');
  if (variantSelect && addButton) {
    const syncVariant = () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      const available = option?.dataset.available === 'true';
      addButton.disabled = !available;
      addButton.textContent = available ? 'Añadir al carrito ⚡' : 'Agotado';
    };
    variantSelect.addEventListener('change', syncVariant);
    syncVariant();
  }

  // Scroll CTA
  document.querySelectorAll('[data-scroll]').forEach(btn => {
    btn.addEventListener('click', () => document.querySelector(btn.dataset.scroll)?.scrollIntoView({behavior:'smooth'}));
  });

  // ---------- Professional AJAX cart ----------
  const drawer = document.querySelector('[data-cart-drawer]');
  const backdrop = document.querySelector('.kc-drawer-backdrop');

  const money = cents => {
    try { return new Intl.NumberFormat('es-ES',{style:'currency',currency:'EUR'}).format(cents/100); }
    catch(e) { return (cents/100).toFixed(2)+' €'; }
  };
  const escapeHTML = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));

  async function getCart() {
    const response = await fetch('/cart.js', {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('cart');
    return response.json();
  }

  async function refreshHeaderCount() {
    try {
      const cart = await getCart();
      document.querySelectorAll('.kc-cart-count').forEach(el => el.textContent = cart.item_count);
    } catch(e) {}
  }

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    backdrop?.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    loadDrawer();
  }

  function closeCart() {
    drawer?.classList.remove('is-open');
    backdrop?.classList.remove('is-open');
    drawer?.setAttribute('aria-hidden','true');
  }

  async function loadDrawer() {
    if (!drawer) return;
    const box = drawer.querySelector('[data-drawer-items]');
    try {
      const cart = await getCart();
      drawer.querySelector('[data-drawer-count]').textContent = cart.item_count;
      drawer.querySelector('[data-drawer-total]').textContent = money(cart.total_price);

      if (!cart.items.length) {
        box.innerHTML = '<div class="kc-empty"><div>🛒</div><h2>Carrito vacío</h2><p>Añade productos para continuar.</p></div>';
        return;
      }

      box.innerHTML = cart.items.map((item, index) => `
        <div class="kc-drawer-item">
          <a href="${item.url}">
            <img src="${item.image || ''}" alt="${escapeHTML(item.product_title)}">
          </a>
          <div>
            <a href="${item.url}"><h3>${escapeHTML(item.product_title)}</h3></a>
            <p>${money(item.final_line_price)}</p>
            <div class="kc-quantity">
              <button type="button" data-dminus="${index+1}">−</button>
              <input value="${item.quantity}" readonly aria-label="Cantidad">
              <button type="button" data-dplus="${index+1}">+</button>
            </div>
          </div>
          <button type="button" data-dremove="${index+1}">Eliminar</button>
        </div>
      `).join('');

      box.querySelectorAll('[data-dminus]').forEach(btn => btn.onclick = () => changeLine(btn.dataset.dminus,-1));
      box.querySelectorAll('[data-dplus]').forEach(btn => btn.onclick = () => changeLine(btn.dataset.dplus,1));
      box.querySelectorAll('[data-dremove]').forEach(btn => btn.onclick = () => setLine(btn.dataset.dremove,0));
    } catch(e) {
      box.innerHTML = '<div class="kc-empty"><p>No se pudo cargar el carrito. Recarga la página.</p></div>';
    }
  }

  async function setLine(line, quantity) {
    await fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({line:Number(line),quantity:Number(quantity)})
    });
    await refreshHeaderCount();
    await loadDrawer();
  }

  async function changeLine(line, delta) {
    const cart = await getCart();
    const item = cart.items[Number(line)-1];
    if (item) await setLine(line, Math.max(0, item.quantity + delta));
  }

  async function addVariant(id, quantity=1) {
    const response = await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({items:[{id:Number(id),quantity:Number(quantity)}]})
    });
    if (!response.ok) throw new Error('add');
    await refreshHeaderCount();
    openCart();
  }

  document.querySelectorAll('[data-quick-add]').forEach(button => {
    button.addEventListener('click', async () => {
      const old = button.textContent;
      button.disabled = true;
      button.textContent = 'Añadiendo…';
      try {
        await addVariant(button.dataset.quickAdd);
        showToast('Producto añadido al carrito ✓');
      } catch(e) {
        showToast('No se pudo añadir el producto');
      } finally {
        button.disabled = false;
        button.textContent = old;
      }
    });
  });

  document.querySelectorAll('.kc-add-cart').forEach(button => {
    button.closest('form')?.addEventListener('submit', async event => {
      event.preventDefault();
      const form = event.currentTarget;
      const response = await fetch('/cart/add.js',{
        method:'POST',
        headers:{Accept:'application/json'},
        body:new FormData(form)
      });
      if (response.ok) {
        await refreshHeaderCount();
        openCart();
        showToast('Producto añadido al carrito ✓');
      } else {
        showToast('Revisa la variante seleccionada');
      }
    });
  });

  document.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));
  document.querySelector('.kc-cart-link')?.addEventListener('click', event => {
    if (drawer) { event.preventDefault(); openCart(); }
  });

  // Support
  const supportPanel = document.querySelector('[data-support-panel]');
  document.querySelector('[data-support-open]')?.addEventListener('click', () => {
    supportPanel?.classList.toggle('is-open');
    supportPanel?.setAttribute('aria-hidden', supportPanel?.classList.contains('is-open') ? 'false' : 'true');
  });
  document.querySelector('[data-support-close]')?.addEventListener('click', () => {
    supportPanel?.classList.remove('is-open');
    supportPanel?.setAttribute('aria-hidden','true');
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      closeCart();
      supportPanel?.classList.remove('is-open');
    }
  });

  refreshHeaderCount();
});
